import { getMonthTabs, ID_TABS } from "../../../helper/MShelper";
import {
  UPDATE_USER_DETAILS,
  UPDATE_SELECTED_BSA,
  UPDATE_LEVEL,
  UPDATE_SELECTED_COUNTRYCODE,
  UPDATE_DT_ACCESS,
  ADD_CHANGED_OUTLETSTATUS,
  REMOVE_CHANGED_OUTLETSTATUS,
  CLEAR_CHANGED_OUTLETSTATUSES,
  UPDATE_ADMIN_ACCESS,
  UPDATE_UCUBE_ACCESS,
  UPDATE_OPSREPORT_ACCESS,
  UPDATE_SELECTED_MONTH,
  UPDATE_SELECTED_TAB_ID,
  UPDATE_DRILLDOWN_DATA,
  UPDATE_KPI_INDICATORS,
} from "../Actions/storeActionTypes";

const initialState = {
  userDetails: {},
  selectedBsa: "",
  level: [],
  selectedCountryCode: "",
  dtAccess: "",
  changedStatuses: [],
  selectedMonth: getMonthTabs()[1].key,
  selectedTabId: ID_TABS.UPCOMING,
  drillDownData: {},
  kpiIndicators: {},
};

const storeReducer = (state = initialState, action) => {
  switch (action.type) {
    case UPDATE_USER_DETAILS: {
      return {
        ...state,
        userDetails: action.payload.userDetails,
      };
    }
    case UPDATE_SELECTED_BSA: {
      return {
        ...state,
        selectedBsa: action.payload.selectedBsa,
      };
    }
    case UPDATE_LEVEL: {
      return {
        ...state,
        level: action?.payload?.level,
      };
    }
    case UPDATE_SELECTED_COUNTRYCODE: {
      return {
        ...state,
        selectedCountryCode: action.payload.selectedCountryCode,
      };
    }
    case UPDATE_DT_ACCESS: {
      return {
        ...state,
        dtAccess: action.payload.dtAccess,
      };
    }
    case UPDATE_ADMIN_ACCESS: {
      return {
        ...state,
        adminAccess: action.payload.adminAccess,
      }
    }
    case UPDATE_UCUBE_ACCESS: {
      return {
        ...state,
        ucubeAccess: action.payload.ucubeAccess,
      }
    }
    case UPDATE_OPSREPORT_ACCESS: {
      return {
        ...state,
        opsReportAccess: action.payload.opsReportAccess,
      }
    }
    case ADD_CHANGED_OUTLETSTATUS:
      return {
        ...state,
        changedStatuses: [...state.changedStatuses, action.payload],
      };
    case REMOVE_CHANGED_OUTLETSTATUS:
      return {
        ...state,
        changedStatuses: state.changedStatuses.filter(
            (status) => status.outletCode !== action.payload
        ),
      };
    case CLEAR_CHANGED_OUTLETSTATUSES:
      return {
        ...state,
        changedStatuses: [],
      };
    case UPDATE_SELECTED_MONTH:
      return {
        ...state,
        selectedMonth: action.payload.selectedMonth,
      };
    case UPDATE_SELECTED_TAB_ID:
      return {
        ...state,
        selectedTabId: action.payload.selectedTabId,
      };
    case UPDATE_DRILLDOWN_DATA: {
      const payload = action?.payload?.drillDownData;
      if (payload === null) {
        return { ...state, drillDownData: {} };
      }
      return {
        ...state,
        drillDownData: {
          ...state.drillDownData,
          [payload.index]: payload.data,
        },
      };
    }
    case UPDATE_KPI_INDICATORS: {
      return {
        ...state,
        kpiIndicators: action.payload.kpiIndicators,
      };
    }
    default:
      return state;
  }
};

export default storeReducer;
